<!-- =========================================================================================
  File Name: VerticalNavMenu.vue
  Description: Vertical NavMenu Component
  Component Name: VerticalNavMenu
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="parentx">
    <vs-sidebar
      class="v-nav-menu items-no-padding"
      v-model="isVerticalNavMenuActive"
      ref="verticalNavMenu"
      default-index="-1"
      :click-not-close="clickNotClose"
      :reduce-not-rebound="reduceNotRebound"
      :parent="parent"
      :hiddenBackground="clickNotClose"
      :reduce="reduce"
      v-hammer:swipe="onMenuSwipe"
    >
      <div @mouseenter="mouseEnter" @mouseleave="mouseLeave">
        <!-- Header -->
        <div
          class="header-sidebar flex items-center"
          style="justify-content: center"
          slot="header"
        >
          <!-- Logo -->
          <router-link
            tag="div"
            class="vx-logo cursor-pointer flex items-center"
            to="/user/dashboard"
          >
            <!-- <logo class="w-10 mr-4 fill-current" />
            <span
              class="vx-logo-text"
              v-show="isMouseEnter || !reduce"
              v-if="title"
              >{{ title }}</span
            > -->
            <img src="@/assets/images/logo/getboarded-logo.svg" width="200px" />
          </router-link>
          <!-- /Logo -->

          <!-- Menu Buttons -->
          <div>
            <!-- Close Button -->
            <template v-if="showCloseButton">
              <feather-icon
                icon="XIcon"
                class="m-0 cursor-pointer"
                @click="
                  $store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)
                "
              />
            </template>

            <!-- Toggle Buttons -->
            <template v-else-if="!showCloseButton && !verticalNavMenuItemsMin">
              <!--<feather-icon
                id="btnVNavMenuMinToggler"
                class="mr-0 cursor-pointer"
                :icon="reduce ? 'CircleIcon' : 'DiscIcon'"
                svg-classes="stroke-current text-primary"
                @click="toggleReduce(!reduce)" />-->
            </template>
          </div>
          <!-- /Menu Toggle Buttons -->
        </div>
        <!-- /Header -->

        <div
          :class="{
            'mx-5': isMouseEnter || !reduce,
            'mx-3': !(isMouseEnter || !reduce),
          }"
        >
          <v-nav-menu-item
            v-if="
              Object.keys(myOrganizations).length &&
              (myOrganizations.subOrgs.length ||
                myOrganizations.superOrgs.length)
            "
            class="my-5 mb-base org-switch-nav-item"
            to="/my-organizations"
            icon="person"
            iconPack="material-icons"
            :featherIcon="false"
            slug="user-dashboard-switch"
          >
            <span v-show="!verticalNavMenuItemsMin" class="truncate py-3"
              >User View</span
            >
            <vs-icon
              class="ml-auto"
              color="white"
              size="20px"
              icon-pack="material-icons"
              icon="unfold_more"
            />
            <!-- <vs-chip class="ml-auto" :color="item.tagColor" v-if="item.tag && (isMouseEnter || !reduce)">{{ item.tag }}</vs-chip> -->
          </v-nav-menu-item>
        </div>

        <!-- Header Shadow -->
        <div class="shadow-bottom" v-show="showShadowBottom" />

        <!-- Menu Items -->

        <component
          :is="scrollbarTag"
          ref="verticalNavMenuPs"
          class="scroll-area-v-nav-menu pt-2"
          :settings="settings"
          @ps-scroll-y="psSectionScroll"
          @scroll="psSectionScroll"
          :key="$vs.rtl"
        >
          <template v-for="(item, index) in menuItemsUpdated">
            <!-- Group Header -->
            <span
              v-if="
                item.header && item.items.length && !verticalNavMenuItemsMin
              "
              class="navigation-header truncate flex"
              :key="`header-${index}`"
              :class="{ 'cursor-pointer': item.header === 'Apps' }"
              @click="
                item.header === 'Apps'
                  ? $router.push({ name: 'user-marketplace' })
                  : null
              "
            >
              <h4>{{ item.header }}</h4>

              <div
                v-if="
                  item.header === 'Boards' &&
                  !hideBoardPing &&
                  !blinkers.readBoardsTip
                "
                class="absolute flex h-4 w-4 blinker z-40 cursor-pointer"
                @click="showBlinkerTip"
                ref="wrapper"
              >
                <span
                  class="animate-ping absolute inline-flex h-full w-full rounded-full opacity-50 blinker-color"
                ></span>
                <span
                  class="relative inline-flex rounded-full h-full w-full blinker-color"
                ></span>
              </div>
              <span v-if="item.header === 'Apps'" class="ml-2">
                <feather-icon
                  icon="ArrowUpRightIcon"
                  svgClasses="w-5 h-5"
                  style="color: #999"
                ></feather-icon>
              </span>
            </span>
            <!-- /Group Header -->

            <template v-else-if="!item.header">
              <!-- Nav-Item -->
              <v-nav-menu-item
                class="org-nav-item"
                v-if="!item.submenu"
                :key="`item-${index}`"
                :index="index"
                :to="item.slug !== 'external' ? item.url : null"
                :href="item.slug === 'external' ? item.url : null"
                :icon="item.icon"
                :target="item.target"
                :isDisabled="item.isDisabled"
                :slug="item.slug"
                :boardName="item.name"
              >
                <span v-show="!verticalNavMenuItemsMin" class="truncate">{{
                  item.name
                }}</span>
                <vs-chip
                  class="ml-auto"
                  :color="item.tagColor"
                  v-if="item.tag && (isMouseEnter || !reduce)"
                  >{{ item.tag }}</vs-chip
                >
              </v-nav-menu-item>

              <template v-else>
                <v-nav-menu-group
                  :key="`group-${index}`"
                  :openHover="openGroupHover"
                  :group="item"
                  :groupIndex="index"
                  :open="isGroupActive(item)"
                />
              </template>
              <!-- /Nav-Group -->
            </template>
          </template>
        </component>
        <!-- /Menu Items -->

        <!-- T & C, Privacy Policy -->
        <hr style="border-top: rgb(244, 246, 251)" />
        <div class="sidebar-footer p-5">
          <div class="sidebar-footer--item">
            <small><a href="/privacy-policy" target="_blank">Privacy</a></small>
            <vs-icon
              class="mx-2"
              size="9px"
              icon="fiber_manual_record"
            ></vs-icon>
            <small><a href="/terms-of-use" target="_blank">T&C</a></small>
            <vs-icon
              class="mx-2"
              size="9px"
              icon="fiber_manual_record"
            ></vs-icon>
            <small><a href="/gdpr-compliance" target="_blank">GDPR</a></small>
            <vs-icon
              class="mx-2"
              size="9px"
              icon="fiber_manual_record"
            ></vs-icon>
            <small><a href="/cookie-policy" target="_blank">Cookies</a></small>
          </div>
        </div>
      </div>
    </vs-sidebar>

    <!-- Swipe Gesture -->
    <!-- Swipe Gesture -->
    <div
      v-if="!isVerticalNavMenuActive"
      class="v-nav-menu-swipe-area"
      v-hammer:swipe="onSwipeAreaSwipe"
    />
    <!-- /Swipe Gesture -->
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import VNavMenuGroup from "./VerticalNavMenuGroup.vue";
import VNavMenuItem from "./VerticalNavMenuItem.vue";

import Logo from "../../Logo.vue";

export default {
  name: "v-nav-menu",
  components: {
    VNavMenuGroup,
    VNavMenuItem,
    VuePerfectScrollbar,
    Logo,
  },
  props: {
    logo: { type: String },
    openGroupHover: { type: Boolean, default: false },
    parent: { type: String },
    reduceNotRebound: { type: Boolean, default: true },
    navMenuItems: { type: Array, required: true },
    title: { type: String },
    hideBoardPing: { type: Boolean },
  },
  data: () => ({
    clickNotClose: false, // disable close navMenu on outside click
    isMouseEnter: false,
    reduce: false, // determines if navMenu is reduce - component property
    showCloseButton: false, // show close button in smaller devices
    settings: {
      // perfectScrollbar settings
      maxScrollbarLength: 60,
      wheelSpeed: 1,
      swipeEasing: true,
    },
    showShadowBottom: false,
    readBoardsTip: false,
  }),
  computed: {
    isGroupActive() {
      return (item) => {
        const path = this.$route.fullPath;
        const routeParent = this.$route.meta
          ? this.$route.meta.parent
          : undefined;
        let open = false;

        let func = (item) => {
          if (item.submenu) {
            item.submenu.forEach((item) => {
              if (
                item.url &&
                (path === item.url || routeParent === item.slug)
              ) {
                open = true;
              } else if (item.submenu) {
                func(item);
              }
            });
          }
        };
        func(item);
        return open;
      };
    },
    autoLoginToken() {
      return this.$store.state.boards.userBoardData.youlabToken;
    },
    userProgress() {
      return this.$store.state.boards.userBoardData.progress;
    },
    personality() {
      return this.$store.state.editor.personality;
    },
    menuItemsUpdated() {
      let reportSet = [];
      const current = this;
      const reportIndex = this.navMenuItems.findIndex(
        (b) => b.header === "Reports"
      );
      current.navMenuItems[reportIndex].items = [];
      // User Report
      if (this.autoLoginToken && this.userProgress === 2) {
        current.navMenuItems[reportIndex].items.push({
          url: `/competency-report`,
          name: "Talent Discovery",
          slug: "user-board",
          icon: "DownloadIcon",
          i18n: "Talent Discovery",
        });
      } else {
        if (
          this.personality.personalityYoulabProgress === 2 &&
          this.personality.personalityYoulabToken
        ) {
          current.navMenuItems[reportIndex].items.push({
            url: `/personality-report`,
            name: "Personality",
            slug: "user-board",
            icon: "DownloadIcon",
            i18n: "Personality",
          });
        }
      }
      let clone = this.navMenuItems.slice();
      let finalNavMenuItem = [...clone, ...reportSet.slice()];
      for (let [index, item] of finalNavMenuItem.entries()) {
        if (item.header && item.items.length && (index || 1)) {
          let i = clone.findIndex((ix) => ix.header === item.header);
          for (let [subIndex, subItem] of item.items.entries()) {
            clone.splice(i + 1 + subIndex, 0, subItem);
          }
        }
      }
      return clone;
    },
    isVerticalNavMenuActive: {
      get() {
        return this.$store.state.isVerticalNavMenuActive;
      },
      set(val) {
        this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", val);
      },
    },
    layoutType() {
      return this.$store.state.mainLayoutType;
    },
    reduceButton: {
      get() {
        return this.$store.state.reduceButton;
      },
      set(val) {
        this.$store.commit("TOGGLE_REDUCE_BUTTON", val);
      },
    },

    isVerticalNavMenuReduced() {
      return Boolean(this.reduce && this.reduceButton);
    },
    verticalNavMenuItemsMin() {
      return this.$store.state.verticalNavMenuItemsMin;
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
    orgData() {
      return this.$store.state.organization.orgData;
    },
    myOrganizations() {
      return this.$store.state.organization.myOrganizations;
    },
    blinkers() {
      return this.$store.state.dashboard.blinkers;
    },
  },
  watch: {
    $route() {
      if (this.isVerticalNavMenuActive && this.showCloseButton)
        this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", false);
    },
    reduce(val) {
      const verticalNavMenuWidth = val
        ? "reduced"
        : this.$store.state.windowWidth < 1200
        ? "no-nav-menu"
        : "default";
      this.$store.dispatch("updateVerticalNavMenuWidth", verticalNavMenuWidth);

      setTimeout(function () {
        window.dispatchEvent(new Event("resize"));
      }, 100);
    },
    layoutType() {
      this.setVerticalNavMenuWidth();
    },
    reduceButton() {
      this.setVerticalNavMenuWidth();
    },
    windowWidth() {
      this.setVerticalNavMenuWidth();
    },
  },
  methods: {
    onMenuSwipe(event) {
      // Swipe Right
      if (event.direction === 4 && this.$vs.rtl) {
        if (this.isVerticalNavMenuActive && this.showCloseButton)
          this.isVerticalNavMenuActive = false;
      }
      // Swipe Left
      else if (event.direction === 2 && !this.$vs.rtl) {
        if (this.isVerticalNavMenuActive && this.showCloseButton)
          this.isVerticalNavMenuActive = false;
      }
    },
    onSwipeAreaSwipe(event) {
      // Swipe Right
      if (event.direction === 4 && !this.$vs.rtl) {
        if (!this.isVerticalNavMenuActive && this.showCloseButton)
          this.isVerticalNavMenuActive = true;
      }
      // Swipe Left
      else if (event.direction === 2 && this.$vs.rtl) {
        if (!this.isVerticalNavMenuActive && this.showCloseButton)
          this.isVerticalNavMenuActive = true;
      }
    },
    psSectionScroll() {
      const scroll_el =
        this.$refs.verticalNavMenuPs.$el || this.$refs.verticalNavMenuPs;
      this.showShadowBottom = scroll_el.scrollTop > 0 ? true : false;
    },
    mouseEnter() {
      if (this.reduce)
        this.$store.commit("UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN", false);
      this.isMouseEnter = true;
    },
    mouseLeave() {
      if (this.reduce)
        this.$store.commit("UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN", true);
      this.isMouseEnter = false;
    },
    setVerticalNavMenuWidth() {
      if (this.windowWidth > 1200) {
        if (this.layoutType === "vertical") {
          // Set reduce
          this.reduce = this.reduceButton ? true : false;

          // Open NavMenu
          this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);

          // Set Menu Items Only Icon Mode
          const verticalNavMenuItemsMin =
            this.reduceButton && !this.isMouseEnter ? true : false;
          this.$store.commit(
            "UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN",
            verticalNavMenuItemsMin
          );

          // Menu Action buttons
          this.clickNotClose = true;
          this.showCloseButton = false;

          const verticalNavMenuWidth = this.isVerticalNavMenuReduced
            ? "reduced"
            : "default";
          this.$store.dispatch(
            "updateVerticalNavMenuWidth",
            verticalNavMenuWidth
          );

          return;
        }
      }

      // Close NavMenu
      this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", false);

      // Reduce button
      if (this.reduceButton) this.reduce = false;

      // Menu Action buttons
      this.showCloseButton = true;
      this.clickNotClose = false;

      // Update NavMenu Width
      this.$store.dispatch("updateVerticalNavMenuWidth", "no-nav-menu");

      // Remove Only Icon in Menu
      this.$store.commit("UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN", false);

      // if(this.layoutType === 'vertical' || (this.layoutType === 'horizontal' && this.windowWidth < 1200))
      // if (this.windowWidth < 1200) {

      //   // Close NavMenu
      //   this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)

      //   // Reduce button
      //   if (this.reduceButton) this.reduce = false

      //   // Menu Action buttons
      //   this.showCloseButton = true
      //   this.clickNotClose   = false

      //   // Update NavMenu Width
      //   this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu')

      //   // Remove Only Icon in Menu
      //   this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', false)

      // } else {

      //   // Set reduce
      //   this.reduce = this.reduceButton ? true : false

      //   // Open NavMenu
      //   this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)

      //   // Set Menu Items Only Icon Mode
      //   const verticalNavMenuItemsMin = (this.reduceButton && !this.isMouseEnter) ? true : false
      //   this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', verticalNavMenuItemsMin)

      //   // Menu Action buttons
      //   this.clickNotClose   = true
      //   this.showCloseButton = false

      //   const verticalNavMenuWidth   = this.isVerticalNavMenuReduced ? "reduced" : "default"
      //   this.$store.dispatch('updateVerticalNavMenuWidth', verticalNavMenuWidth)
      // }
    },
    toggleReduce(val) {
      this.reduceButton = val;
      this.setVerticalNavMenuWidth();
    },
    showBlinkerTip() {
      this.$emit("openBoardTip", {
        wrapper: this.$refs.wrapper,
        val: true,
      });

      window.addEventListener("click", this.handleClickOutside);
    },
  },
  mounted() {
    this.setVerticalNavMenuWidth();
  },
  created() {
    if (this.isUserLoggedIn) {
      this.$store
        .dispatch("boards/fetchUserBoardData", this.$store.state.auth.user._id)
        .then((res) => {
          if (res.data) {
            this.organizationIds = res.data.boardData.organizationId;
          }
        })
        .catch((err) => {
          throw err;
        });
    }
    this.$store
      .dispatch("boards/fetchUserBoardData", this.$store.state.auth.user._id)
      .then((res) => {})
      .catch((err) => {
        throw err;
      });
    this.$store
      .dispatch("users/fetchUser", this.$store.state.auth.user._id)
      .then((res) => {
        this.$store.commit("editor/SET_PERSONALITY", res.data.personality[0]);
      });
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/verticalNavMenu.scss";

.org-nav-item.vs-sidebar-item-active .router-link-active {
  background: none !important;
  box-shadow: none !important;
}

.vs-sidebar-primary .vs-sidebar-item-active {
  background: none !important;
}

.org-switch-nav-item.vs-sidebar--item {
  background: rgba(
    var(--vs-primary, "#F2C244"),
    1
  ) !important; /* #F2C244!important; */
  border-radius: 8px !important;
  box-shadow: none !important;
  // margin: 0 25px;
  // padding: 0!important;
}

.org-switch-nav-item.vs-sidebar--item span {
  color: white;
}

.org-nav-item.vs-sidebar-item-active .router-link-active span svg {
  color: rgba(
    var(--vs-primary, "#F2C244"),
    1
  ) !important; /* #F2C244!important; */
}

.org-nav-item.vs-sidebar-item-active .router-link-active span:nth-child(2) {
  color: rgba(
    var(--vs-primary, "#F2C244"),
    1
  ) !important; /* #F2C244!important; */
}

// .org-nav-item.vs-sidebar-item-active .router-link-active span{
//   color: rgba(
//     var(--vs-primary, "#F2C244"),
//     1
//   ) !important; /* #F2C244!important; */
// }

.v-nav-menu .scroll-area-v-nav-menu {
  max-height: calc(var(--vh, 1vh) * 100 - 250px) !important;
}

.sidebar-footer {
  position: absolute;
  bottom: 0;
}

.sidebar-footer--item {
  display: flex;
  align-items: center;
  color: #a9a9a9 !important;
}

.sidebar-footer--item a {
  color: #a9a9a9 !important;
}
</style>

<style scoped>
.con-vs-avatar >>> .vs-avatar--text {
  transform: translate(-50%, -50%) scale(0.5) !important;
  color: rgb(240, 70, 70) !important;
}

.blinker {
  left: 8em;
  top: 6em;
}
.blinker-color {
  background: rgba(var(--vs-primary, "#F2C244"), 1) !important;
}
</style>
